import React from 'react';
import enhance from './DealForm.enhancer';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { DatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import StarsIcon from '@material-ui/icons/Stars';
import Chip from '@material-ui/core/Chip';
import StarRatings from 'react-star-ratings';
import Dialog from '@material-ui/core/Dialog';
import { dealStatuses } from '../../../constants';

import { RadioIcon, RadioFillIcon, grey, primary } from '../../../style';

class DealForm extends React.Component {
  constructor() {
    super();

    this.initialState = {
      completedDeals: 0,
      submitAttempted: false,
      sendPropsalDialogOpen: false,
      newDeal: {
        productAndCommission: '',
        productOnly: '',
        commissionOnly: '',
        payout: '',
        payoutErrorText: '',
        platform: '',
        dueDate: new Date(),
        commissionDetails: '',
        contentDetails: '',
        productDeliverableDetails: ''
      }
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    // get completed deal count for user
    let dealsQuery = this.props.firestore
      .collection('deals')
      .where('status', '==', dealStatuses.COMPLETE);

    if (this.props.profile.isCompany) {
      dealsQuery = dealsQuery.where(
        'influencerId',
        '==',
        this.props.dealRecipient.id
      );
    } else {
      dealsQuery = dealsQuery.where(
        'companyId',
        '==',
        this.props.dealRecipient.id
      );
    }
    dealsQuery.get().then(dealSnapshot => {
      this.setState({
        completedDeals: dealSnapshot.docs.length
      });
    });

    this.setInitialDeal();
  }

  setInitialDeal() {
    const deal = this.props.currentDeal ? this.props.currentDeal : {};
    const campaign = deal.campaign ? deal.campaign : this.props.campaign;

    if (deal && deal.currentProposal) {
      this.setState({
        newDeal: {
          ...deal.currentProposal,
          dueDate: deal.currentProposal.dueDate.toDate()
          // dueDate: new Date()
        }
      });
    } else {
      this.setState({
        newDeal: this.setFieldsFromCamapign(deal, campaign)
      });
    }
  }

  setFieldsFromCamapign(deal, campaign) {
    const newDeal = {
      dueDate: new Date()
    };

    //commission and product
    if (
      !deal.productAndCommission &&
      !deal.productOnly &&
      !deal.commissionOnly
    ) {
      newDeal.productAndCommission = campaign.productAndCommission;
      newDeal.productOnly = campaign.productOnly;
      newDeal.commissionOnly = campaign.commissionOnly;
    }

    //commission amount
    if (!deal.payout) {
      newDeal.payout = campaign.payoutMin;
    }

    //platform
    if (!deal.platform) {
      newDeal.platform = campaign.platform;
    }

    newDeal.commissionDetails = '';

    return newDeal;
  }

  prodCommissionHandler = e => {
    const key = e.target.value;
    this.setState({
      newDeal: {
        ...this.state.newDeal,
        productAndCommission: key === 'productAndCommission',
        commissionOnly: key === 'commissionOnly',
        productOnly: key === 'productOnly'
      }
    });
  };

  getProdCommissionValue() {
    if (this.state.newDeal.productAndCommission) {
      return 'productAndCommission';
    }
    if (this.state.newDeal.commissionOnly) {
      return 'commissionOnly';
    }
    if (this.state.newDeal.productOnly) {
      return 'productOnly';
    }
    return '';
  }

  getPlatformValue() {
    if (this.state.newDeal.platform === 'youtube') {
      return 'youtube';
    }
    if (this.state.newDeal.platform === 'twitch') {
      return 'twitch';
    }
    if (this.state.newDeal.platform === 'instagram') {
      return 'instagram';
    }
    return '';
  }

  changeHandler(e) {
    this.setState({
      newDeal: {
        ...this.state.newDeal,
        [e.target.name]: e.target.value
      }
    });
  }

  handleDateChange(newDate) {
    this.setState({
      newDeal: {
        ...this.state.newDeal,
        dueDate: newDate
      }
    });
  }

  openSubmitProposalDialog = () => {
    this.setState({
      sendPropsalDialogOpen: true
    });
  };

  closeSubmitProposalDialog = () => {
    this.setState({
      sendPropsalDialogOpen: false
    });
  };

  submitDealProposal() {
    if (!this.state.newDeal.productOnly && this.state.newDeal.payout < 25) {
      this.setState({
        submitAttempted: true,
        newDeal: {
          ...this.state.newDeal,
          payoutErrorText: 'payout must be a minimum of $25'
        }
      });
    } else {
      if (this.props.currentDeal) {
        this.props.submitDealProposalHandler(
          this.props.currentDeal.id,
          this.props.user.uid,
          {
            ...this.state.newDeal,
            payout: this.state.newDeal.productOnly
              ? 0
              : this.state.newDeal.payout,
            commissionDetails: this.state.newDeal.productOnly
              ? ''
              : this.state.newDeal.commissionDetails
          },
          this.props.onProposalComplete
        );
      } else {
        const isCompany = this.props.profile.isCompany;
        this.props.createNewProposalHandler(
          isCompany ? this.props.dealRecipient.id : this.props.user.uid,
          isCompany ? this.props.user.uid : this.props.dealRecipient.id,
          {
            ...this.state.newDeal,
            payout: this.state.newDeal.productOnly
              ? 0
              : this.state.newDeal.payout,
            commissionDetails: this.state.newDeal.productOnly
              ? ''
              : this.state.newDeal.commissionDetails
          },
          this.props.campaign.id,
          isCompany,
          this.props.user.uid,
          this.props.onProposalComplete
        );
      }
      this.props.handleBackClick();
    }
  }

  render() {
    const {
      classes,
      handleBackToListClick,
      currentDeal,
      campaign,
      dealRecipient
    } = this.props;
    const { newDeal, completedDeals } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <div className={classes.pageTitle} onClick={handleBackToListClick}>
            <Typography variant="h6">
              <ArrowBackIcon className={classes.backButton} />
              Back
            </Typography>
          </div>
          <Paper className={classes.root}>
            <Grid container direction="row" spacing={6}>
              <Grid item>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  className={classes.userPanel}
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <img
                      src={
                        currentDeal
                          ? currentDeal.user.profilePictureUrl
                          : dealRecipient.profilePictureUrl
                      }
                      className={classes.userPic}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingBottom: 0 }}>
                    <Typography variant="h6">
                      {currentDeal
                        ? currentDeal.user.displayName
                        : dealRecipient.displayName}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <Typography>
                      <StarRatings
                        rating={
                          currentDeal
                            ? currentDeal.user.rating
                            : dealRecipient.rating
                        }
                        starRatedColor="#ffbb44"
                        starDimension="1rem"
                        starSpacing={2}
                        name="rating"
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                    <Typography color="primary" className={classes.deal}>
                      {completedDeals} Completed Deals
                    </Typography>
                    <Divider />
                  </Grid>
                  <Grid
                    item
                    container
                    justify="center"
                    direction="row"
                    spacing={1}
                  >
                    {currentDeal
                      ? currentDeal.user.interests &&
                        currentDeal.user.interests.map(interest => {
                          return (
                            <Grid item>
                              {' '}
                              <Chip label={interest} />
                            </Grid>
                          );
                        })
                      : dealRecipient.interests &&
                        dealRecipient.interests.map(interest => {
                          return (
                            <Grid item>
                              {' '}
                              <Chip label={interest} />
                            </Grid>
                          );
                        })}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm xs={12} container spacing={4}>
                <Grid container item xs={12} direction="column" spacing={4}>
                  <Grid item align="center">
                    <div className={classes.offerTerms}>
                      <Typography variant="h6">Offer Terms</Typography>
                      <Divider />
                    </div>
                  </Grid>

                  <Grid item container direction="row">
                    <Grid item sm={6}>
                      <RadioGroup
                        aria-label="prodCommission"
                        name="prodCommission"
                        className={classes.radioGroup}
                        onChange={this.prodCommissionHandler}
                        value={this.getProdCommissionValue()}
                      >
                        {campaign && campaign.productOnly ? (
                          ''
                        ) : (
                          <FormControlLabel
                            value="productAndCommission"
                            control={
                              <Radio
                                color="primary"
                                icon={<RadioIcon htmlColor={grey} />}
                                checkedIcon={<RadioFillIcon htmlColor={grey} />}
                              />
                            }
                            label="Product + Commission"
                            labelPlacement="end"
                          />
                        )}
                        {campaign && campaign.productOnly ? (
                          ''
                        ) : (
                          <FormControlLabel
                            value="commissionOnly"
                            control={
                              <Radio
                                color="primary"
                                icon={<RadioIcon htmlColor={grey} />}
                                checkedIcon={<RadioFillIcon htmlColor={grey} />}
                              />
                            }
                            label="Commission Only"
                            labelPlacement="end"
                          />
                        )}
                        <FormControlLabel
                          value="productOnly"
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon htmlColor={grey} />}
                              checkedIcon={<RadioFillIcon htmlColor={grey} />}
                            />
                          }
                          label="Product Only"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item sm={6}>
                      <RadioGroup
                        aria-label="platformSelect"
                        name="platformSelect"
                        className={classes.radioGroup}
                        onChange={this.platformChangeHandler}
                        value={this.getPlatformValue()}
                      >
                        <FormControlLabel
                          value="youtube"
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon htmlColor={grey} />}
                              checkedIcon={<RadioFillIcon htmlColor={grey} />}
                            />
                          }
                          label="Youtube"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="twitch"
                          disabled
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon htmlColor={grey} />}
                              checkedIcon={<RadioFillIcon htmlColor={grey} />}
                            />
                          }
                          label="Twitch"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="instagram"
                          disabled
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon htmlColor={grey} />}
                              checkedIcon={<RadioFillIcon htmlColor={grey} />}
                            />
                          }
                          label="Instagram"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row" spacing={4}>
                  {newDeal.productOnly ? (
                    ''
                  ) : (
                    <Grid item sm={6}>
                      <Typography gutterBottom align="left" display="block">
                        Commission Amount
                      </Typography>
                      <TextField
                        id="payout"
                        name="payout"
                        variant="outlined"
                        className={classes.title}
                        value={newDeal.payout}
                        onChange={this.changeHandler.bind(this)}
                        type="number"
                        error={
                          this.state.submitAttempted &&
                          this.state.newDeal.payoutErrorText
                            ? true
                            : false
                        }
                        helperText={
                          this.state.submitAttempted
                            ? this.state.newDeal.payoutErrorText
                            : ''
                        }
                      />
                    </Grid>
                  )}
                  <Grid item sm={6}>
                    <Typography gutterBottom align="left" display="block">
                      Date to be published
                    </Typography>
                    <DatePicker
                      disableToolbar
                      variant="inline"
                      value={newDeal.dueDate}
                      onChange={this.handleDateChange.bind(this)}
                    />
                  </Grid>
                </Grid>
                {!newDeal.productOnly && (
                  <Grid container item xs={12}>
                    <Typography gutterBottom align="left" display="block">
                      Commission Details
                    </Typography>
                    <TextField
                      id="commissionDetails"
                      name="commissionDetails"
                      variant="outlined"
                      disabled
                      multiline
                      className={classes.details}
                      value={
                        'Company will escrow funds upon deal acceptance. Funds will be transferred to the content creator once the content has been accepted.'
                      }
                      // onChange={this.changeHandler.bind(this)}
                    />
                  </Grid>
                )}
                <Grid container item xs={12}>
                  <Typography gutterBottom align="left" display="block">
                    Content to be Produced
                  </Typography>
                  <TextField
                    id="contentDetails"
                    name="contentDetails"
                    variant="outlined"
                    placeholder="Please enter details about the required content"
                    multiline
                    className={classes.details}
                    value={newDeal.contentDetails}
                    onChange={this.changeHandler.bind(this)}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Typography gutterBottom align="left" display="block">
                    Product Deliverable
                  </Typography>
                  <TextField
                    id="productDeliverableDetails"
                    name="productDeliverableDetails"
                    variant="outlined"
                    placeholder="Please enter details about the product being delivered"
                    multiline
                    className={classes.details}
                    value={newDeal.productDeliverableDetails}
                    onChange={this.changeHandler.bind(this)}
                  />
                </Grid>
                <Grid container item xs={12} justify="flex-end" spacing={2}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleBackToListClick}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      onClick={this.openSubmitProposalDialog.bind(this)}
                    >
                      Send Proposal
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </main>
        <Dialog
          id="confirm-send-proposal-dialog"
          open={this.state.sendPropsalDialogOpen}
          onClose={this.props.closeSubmitProposalDialog}
          disableAutoFocus={true}
          onBackdropClick={this.closeSubmitProposalDialog.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography
            variant="body1"
            align="center"
            className={classes.termsText}
          >
            These terms cannot be changed after they have been accepted.
          </Typography>
          {/* <Typography variant="body1" align="center">
            (Active deals for this campaign will be unaffected)
          </Typography> */}
          <div>
            <Button
              color="secondary"
              variant="contained"
              onClick={this.closeSubmitProposalDialog.bind(this)}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.submitDealProposal.bind(this)}
              className={classes.submitAcceptButtons}
            >
              Send
            </Button>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

DealForm.propTypes = {
  currentDeal: PropTypes.object,
  handleBackClick: PropTypes.func,
  user: PropTypes.func
};

export default enhance(DealForm);



// WEBPACK FOOTER //
// ./src/components/deals/new-deal/DealForm.js